import { Component, OnInit,Inject } from '@angular/core';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
@Component({
  selector: 'app-plan-share-modal',
  templateUrl: './plan-share-modal.component.html',
  styleUrls: ['./plan-share-modal.component.css']
})
export class PlanShareModalComponent implements OnInit {
  PlanForm: FormGroup;loading:boolean=false;submitted:boolean=false;
  favoritePlans: string;leadId:any;
  copypaymentlink:any;
  show_copy:boolean=false;
  plans = [
    // {
    //   'id':1,
    //   'name':'Glamyo Silver Care Plan'
    // },
    // {
    //   'id':2,
    //   'name':'Glamyo Gold Care Plan'
    // },
    {
      'id':3,
      'name':'Glamyo Platinum Care Plan'
    },
    // {
    //   'id':4,
    //   'name':'Glamyo All Care Plan'
    // }

  ];


  constructor(public dialogRef: MatDialogRef<PlanShareModalComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog,private formBuilder: FormBuilder,private leadapi:LeadsService,private sharedapi:SharedService) { 

    this.PlanForm = this.formBuilder.group({ 
      'plan_type' : [3, Validators.required],
      'payment_type':[3],
      'description' : ['Glamyo Platinum Care Plan'],
      'amount':[1499],
      'patient_name':[],
      'leadid' : [this.data['lead_id']],
      'lab_lead_id' : [this.data['lab_lead_id']]
      
      
      
    });
    console.log(data);
    //this.leadId = this.data;

  }

  get f() { return this.PlanForm.controls; }

  ngOnInit(): void {
  }

  copyToClipboard(element) {
    element.select();
    document.execCommand('copy');
    this.sharedapi.presentToast('Link copied to clipboard.');
  }

  share_plan(){
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.PlanForm.invalid) {
        this.loading = false;
        return;
    }
    //console.log(this.PlanForm.value);return false;
    
    //this.PlanForm.value.lead_id = this.data['lead_id'];

    this.leadapi.share_plans(this.PlanForm.value)
    .subscribe((data:any) => {
        this.submitted = false;
        this.loading = false;
        console.log(data);
        if(data.status)
        {
          this.sharedapi.presentToast("Payment Link Sent Successfully!");
          this.show_copy = true;
          this.copypaymentlink = data.data.short_url;
           
        }
        else
        {
            this.sharedapi.presentToast(data.msg);
            this.ClosePlanModal();
        }
      }, error => 
        {
            this.sharedapi.checkError(error);
        });
  }

  ClosePlanModal(): void {
    this.dialogRef.close();
  } 

}
